import * as React from "react";
import { connect } from "react-redux";

import {
  FriendbuyLogo as FriendbuyLogoComponent,
  FriendbuyLogoProps,
} from "../../components/FriendbuyLogo/FriendbuyLogo";

import { StoreState } from "../../reducers";
import { getMerchantId } from "../../reducers/methods";

class FriendbuyLogo extends React.Component<FriendbuyLogoProps> {
  render() {
    return <FriendbuyLogoComponent {...this.props} />;
  }
}

interface MapStateToPropsValue {
  merchantId: ReturnType<typeof getMerchantId>;
}

function mapStateToProps(state: StoreState): MapStateToPropsValue {
  return {
    merchantId: getMerchantId(state),
  };
}

export default connect(mapStateToProps)(FriendbuyLogo);
